<div class="border dialog-translate">
    <app-translation-panel #appTranslationPanel [refType]="formatReferenceType" [onClickClose]="onClickClose.bind(this)" 
    [action]="action" [openAsDialog]="true" [referenceId]="referenceId" [referenceType]="referenceType" [selectedLanguage]="selectedLanguage"></app-translation-panel>
</div>


